// extracted by mini-css-extract-plugin
export default {"skeletons":"CarGridState_skeletons__56pq8","skeleton":"CarGridState_skeleton__Sqe0W","shimmer":"CarGridState_shimmer__qh8+R","box":"CarGridState_box__LX8vW"};